import React from 'react';
import PropTypes from 'prop-types';
import { Icon as AntdIcon } from 'antd';
import styled from 'styled-components';
import Svg from '../Svg/Svg';

const StyledIcon = styled(AntdIcon)`
    svg {
        position: relative;
        top: 1px;
        width: ${props => props.size};
        height: ${props => props.size};
    }

    &.anticon-spin {
        svg {
            animation: loadingCircle 1s infinite linear;
        }
    }
`;

class Icon extends React.Component {
    static propTypes = {
        inheritColor: PropTypes.bool
    };

    static defaultProps = {
        inheritColor: true
    };

    render() {
        const { props } = this;
        const { inheritColor, type, ...restProps } = props;

        if (type && type.startsWith('cla-')) {
            const [, claType] = type.split('cla-');

            const color = inheritColor === false ? '' : 'currentColor';
            const size =
                props.style && props.style.fontSize
                    ? props.style.fontSize
                    : '16px';

            const ClaSvg = () => <Svg color={color} type={claType} />;

            return <StyledIcon size={size} component={ClaSvg} {...restProps} />;
        }

        return <AntdIcon type={type} {...restProps} />;
    }
}

export default Icon;
